<template>
    <p>
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
        {{ userStore.user.address }}
        <br />
        {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        <br />
        {{ userStore.user.ssn }}
        <br />
        <br />
        {{ creditBureau.address_name }}
        <br />
        {{ creditBureau.street_address }}
        <br />
        {{ creditBureau.city }}, {{ creditBureau.state_abbrev }} {{ creditBureau.zipcode }}
        <br />
        <br />
        Date: {{ date }}
    </p>
    <!-- <p>
        <strong>RE:</strong> You Violated the United States Code Law 15 U.S.C. § 1681i (6) Notice of Results of Re-investigation. I demand you to comply.
    </p> -->
    <p>
        <strong>ATTN:</strong> {{ creditBureau.name }} Legal Department,
    </p>
    <p class="letter-content">
        You are reporting inaccurate and incomplete credit information.
        The credit report you provided shows a history of payment or payments being made late that are not proven and are incorrect.
        The items below should all be removed from my consumer report under 15 US Code 1681 a(2)(A)(i) Late Payments are transactions
        and all transactions are excluded from a consumer report. I was never late.
    </p>
    <template v-for="(creditor, index) in reportStore.getSelectedAccounts(1, creditBureau.id)">
        <p>
            Creditor: <strong>{{ creditor.furnisher_name }}</strong>
            <br />
            Account#: <strong>{{ creditor.account_number }}</strong>
            <br />
            Late Payment Date:
            <mark>{{ creditor.late_status }}</mark> – I was never late.
            <br />
            Please remove this inaccurate late payment for account <strong>{{ creditor.account_number }}</strong> to <strong>payed as agreed</strong>.
        </p>
    </template>
    <p class="letter-content">
        If you fail to remove the above items,
        I demand that you as REQUIRED BY MY STATE’S LAWS and also by the FEDERAL LAWS that govern your behavior while
        dealing with consumer reports to include your RECEIPT and/or your REPORTING of them, to fully document in testimony to every single one even each any
        and or all of the facts related to this allegation withstanding none.
    </p>
    <p>
        Sincerely,
        <br />
        <br />
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
        <br />
        <strong>See Enclosed: Copy of Account showing Inaccurate Late Pay</strong>
    </p>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore()
            };
        }
    };
</script>
